module.exports = {
	"generation": 12,
	"links_in_ad": 3,
	"items": [
		{
			"id": 399,
			"name": "Professional Express Logo Design",
			"url": "https://studio.envato.com/explore/logo-design/399-professional-express-logo-design",
			"price_from": 50
		},
		{
			"id": 939,
			"name": "Professional Logo Design",
			"url": "https://studio.envato.com/explore/logo-design/939-professional-logo-design",
			"price_from": 100
		},
		{
			"id": 6513,
			"name": "Logo Vectorization",
			"url": "https://studio.envato.com/explore/photo-editing/6513-vector-redraw-your-logo",
			"price_from": 20
		},
		{
			"id": 17340,
			"name": "Game Development and Design",
			"url": "https://studio.envato.com/explore/mobile-design-development/17340-game-development-design-reskin",
			"price_from": 150
		},
		{
			"id": 9740,
			"name": "Mobile-Friendly Redesign for Existing WordPress Site",
			"url": "https://studio.envato.com/explore/mobile-design-development/9740-make-wordpress-existing-site-mobile-responsive",
			"price_from": 150
		},
		{
			"id": 2759,
			"name": "Product Background Removal",
			"url": "https://studio.envato.com/explore/photo-editing/2759-product-background-removal-for-10-photos",
			"price_from": 20
		},
		{
			"id": 5108,
			"name": "Adaptive Logo Design",
			"url": "https://studio.envato.com/explore/logo-design/5108-adaptive-logo-design",
			"price_from": 60
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./config/sites/studio-recommendations/photodune.json
// module id = 236
// module chunks = 1 2